{
  "{account} needs to sign in again.": "{account} doit se reconnecter.",
  "{account} no longer has access to Johku Hub.": "{account} n'a plus accès à Johku Hub.",
  "{done} of {total}": "{done} sur {total}",
  "{left} of {total} left": "{left} sur {total} restants",
  "{n} by email": "{n} par e-mail",
  "{n} by push": "{n} par notification",
  "{n} customer waiting for a reply": "{n} client attend une réponse",
  "{n} customers waiting for a reply": "{n} clients attendent une réponse",
  "{n} message": "{n} message",
  "{n} message hasn't been sent yet and will be lost.": "{n} message n'a pas encore été envoyé et sera perdu.",
  "{n} messages": "{n} messages",
  "{n} messages haven't been sent yet and will be lost.": "{n} messages n'ont pas encore été envoyés et seront perdus.",
  "{n} more: search by name.": "{n} de plus : recherchez par nom.",
  "{n} of {total}": "{n} sur {total}",
  "{n} pcs": "{n} pce",
  "{n} shop chosen": "{n} boutique choisie",
  "{n} shops chosen": "{n} boutiques choisies",
  "{n} ticket": "{n} billet",
  "{n} tickets": "{n} billets",
  "{n} unread": "{n} non lus",
  "{n} unread conversation": "{n} conversation non lue",
  "{n} unread conversations": "{n} conversations non lues",
  "{n} use left": "{n} utilisation restante",
  "{n} uses left": "{n} utilisations restantes",
  "{name} ({n} member)": "{name} ({n} membre)",
  "{name} ({n} members)": "{name} ({n} membres)",
  "{name} and {n} more": "{name} et {n} autres",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} vous a envoyé un message dans Johku Hub ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} vous a envoyé un message dans Johku Hub.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} peut vendre ses produits dans votre canal de vente. Dès qu'ils acceptent, Johku le met en place.",
  "{shop} sent you a message about your order {order}.": "{shop} vous a envoyé un message au sujet de votre commande {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} aimerait échanger avec vous. Répondez ou acceptez pour continuer.",
  "Accept": "Accepter",
  "Accepted the offer: {channel}, {commission} % commission.": "A accepté l'offre : {channel}, commission de {commission} %.",
  "Accepted, being put into effect in Johku": "Acceptée, en cours de mise en place dans Johku",
  "Accepted, but Johku couldn't put it into effect: {error}": "Acceptée, mais Johku n'a pas pu la mettre en place : {error}",
  "Accepted, in effect in Johku": "Acceptée, en place dans Johku",
  "Access and instructions": "Instructions d'accès et d'utilisation",
  "Accounts": "Comptes",
  "Accounts and settings": "Comptes et paramètres",
  "Add account": "Ajouter un compte",
  "Add an account": "Ajouter un compte",
  "All": "Tous",
  "All caught up": "Tout est lu",
  "All incidents": "Tous les incidents",
  "All orders": "Toutes les commandes",
  "All shops": "Toutes les boutiques",
  "All your shops ({n})": "Toutes vos boutiques ({n})",
  "Allow": "Autoriser",
  "Allow {app} to use Johku Hub?": "Autoriser {app} à utiliser Johku Hub ?",
  "an assistant": "un assistant",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "Un assistant demande à utiliser vos conversations Johku Hub. Connectez-vous d'abord.",
  "As {name}": "En tant que {name}",
  "Ask the shop": "Demandez à la boutique",
  "Attach a file": "Joindre un fichier",
  "Back": "Retour",
  "Between organisations": "Entre organisations",
  "Booking": "Réservation",
  "Can't load the collections right now.": "Impossible de charger les collections pour le moment.",
  "Can't load the list of organisations right now.": "Impossible de charger la liste des organisations pour le moment.",
  "Can't reach Johku Hub. Check your connection and try again.": "Impossible de joindre Johku Hub. Vérifiez votre connexion et réessayez.",
  "Cancel": "Annuler",
  "Cancelled": "Annulé",
  "Cause found, being fixed": "Cause identifiée, correction en cours",
  "Choose a conversation": "Choisissez une conversation",
  "Chosen shops": "Boutiques choisies",
  "Close": "Fermer",
  "Code sent to {email}": "Code envoyé à {email}",
  "Codes": "Codes",
  "Commission (%)": "Commission (%)",
  "Confirmed": "Confirmé",
  "Conversation": "Conversation",
  "Conversations with the Johku team and shops show up here.": "Les conversations avec l'équipe Johku et les boutiques s'affichent ici.",
  "Copied": "Copié",
  "Copy the code": "Copier le code",
  "customer": "client",
  "Customer": "Client",
  "Decline": "Refuser",
  "Declined": "Refusée",
  "Declined the offer.": "A refusé l'offre.",
  "Deny": "Refuser",
  "Done": "Terminé",
  "Download": "Télécharger",
  "Downloading {name}": "Téléchargement de {name}",
  "E.g. Card payments fail": "P. ex. Les paiements par carte échouent",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Chaque membre le reçoit dans sa propre conversation avec la boutique, et leurs réponses vous parviennent une à une.",
  "Email address": "Adresse e-mail",
  "Email those who don't have the app": "Envoyer un e-mail à ceux qui n'ont pas l'application",
  "Event times, cancellations and the shop's replies.": "Horaires des événements, annulations et réponses de la boutique.",
  "Every shop": "Toutes les boutiques",
  "Everything you've bought from Johku shops, in one place.": "Tout ce que vous avez acheté dans les boutiques Johku, au même endroit.",
  "Expired {date}": "Expiré le {date}",
  "Find a shop": "Trouver une boutique",
  "Fixed, monitoring": "Corrigé, sous surveillance",
  "For": "Pour",
  "For every shop": "Pour toutes les boutiques",
  "For: {shops}": "Pour : {shops}",
  "Get started": "Premiers pas",
  "Get told about new messages": "Soyez averti des nouveaux messages",
  "Getting the tickets…": "Chargement des billets…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Les cartes cadeaux et autres codes que vous achetez dans les boutiques Johku s'affichent ici.",
  "Hide": "Masquer",
  "Hide used and expired codes": "Masquer les codes utilisés et expirés",
  "Home": "Accueil",
  "In messages": "Dans les messages",
  "Incidents": "Incidents",
  "Incidents in Johku": "Incidents sur Johku",
  "Investigating": "En cours d'analyse",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Il est valable 10 minutes. Si vous ne l'avez pas demandé, vous pouvez ignorer cet e-mail.",
  "It opens signed in, and stays open in the background": "Elle s'ouvre connectée et reste ouverte en arrière-plan",
  "It sees only what you see in Johku Hub, and every use is logged.": "Il ne voit que ce que vous voyez dans Johku Hub, et chaque utilisation est consignée.",
  "Johku account": "Compte Johku",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub ne fonctionne pas pour le moment. Réessayez dans un instant.",
  "Johku Hub sign-in code: {code}": "Code de connexion Johku Hub : {code}",
  "Johku status: {title}": "Statut Johku : {title}",
  "Kind of conversation": "Type de conversation",
  "Know when things change": "Sachez quand quelque chose change",
  "Language": "Langue",
  "Loading…": "Chargement…",
  "Main menu": "Menu principal",
  "Maintenance": "Maintenance",
  "Make an offer": "Faire une offre",
  "Members of": "Membres de",
  "Members' replies come as conversations of their own.": "Les réponses des membres arrivent comme des conversations à part.",
  "Message": "Message",
  "Message (optional)": "Message (facultatif)",
  "Message the seller about your order and get told when they reply.": "Écrivez au vendeur au sujet de votre commande et soyez averti de sa réponse.",
  "Message to the shops": "Message aux boutiques",
  "Messages": "Messages",
  "Messages can't be reached right now.": "Les messages ne sont pas accessibles pour le moment.",
  "My Johku": "My Johku",
  "Name, sign-in and deleting the account": "Nom, connexion et suppression du compte",
  "New conversation": "Nouvelle conversation",
  "New incident": "Nouvel incident",
  "New message from {name} in Johku Hub": "Nouveau message de {name} dans Johku Hub",
  "New message from {shop}": "Nouveau message de {shop}",
  "New message: {shop}, order {order}": "Nouveau message : {shop}, commande {order}",
  "New messages in Johku Hub": "Nouveaux messages dans Johku Hub",
  "Next up": "À venir",
  "No conversations yet": "Pas encore de conversations",
  "No conversations yet. Start one with the pen above.": "Pas encore de conversations. Commencez-en une avec le crayon ci-dessus.",
  "No email? It can take a minute. Check the spam folder too.": "Pas d'e-mail ? Cela peut prendre une minute. Vérifiez aussi le dossier spam.",
  "No incidents in the last 30 days.": "Aucun incident au cours des 30 derniers jours.",
  "No matches.": "Aucun résultat.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Pas encore de messages sur cette commande. Le client reçoit un e-mail avec un lien vers la page de la commande, où il peut lire et répondre.",
  "No messages yet": "Pas encore de messages",
  "No messages yet.": "Pas encore de messages.",
  "No valid codes": "Aucun code valable",
  "None of the shop's collections has members yet.": "Aucune collection de la boutique n'a encore de membres.",
  "Not sent: {error}": "Non envoyé : {error}",
  "Not shown yet": "Pas encore visible",
  "Not working": "Ne fonctionne pas",
  "Nothing matches “{query}”.": "Aucun résultat pour « {query} ».",
  "Notice": "Information",
  "Notifications are blocked for this site in the browser's settings.": "Les notifications sont bloquées pour ce site dans les paramètres du navigateur.",
  "Notifications are off for Johku Hub in the phone's settings.": "Les notifications de Johku Hub sont désactivées dans les réglages du téléphone.",
  "Notifications of new messages: {name}": "Notifications des nouveaux messages : {name}",
  "Now": "Maintenant",
  "Offer a sales channel": "Proposer un canal de vente",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Offre : vendez vos produits sur {channel} avec une commission de {commission} %.",
  "Offline": "Hors ligne",
  "Offline. {n} message will send when the connection returns.": "Hors ligne. {n} message sera envoyé au retour de la connexion.",
  "Offline. {n} messages will send when the connection returns.": "Hors ligne. {n} messages seront envoyés au retour de la connexion.",
  "Offline. Messages will send when the connection returns.": "Hors ligne. Les messages seront envoyés au retour de la connexion.",
  "Offline. These are the codes saved on this phone ({time}).": "Hors ligne. Voici les codes enregistrés sur ce téléphone ({time}).",
  "Offline. These are the orders saved on this phone.": "Hors ligne. Voici les commandes enregistrées sur ce téléphone.",
  "Offline. These are the tickets saved on this phone ({time}).": "Hors ligne. Voici les billets enregistrés sur ce téléphone ({time}).",
  "OK": "OK",
  "One use": "Une utilisation",
  "Open Johku App": "Ouvrir Johku App",
  "Open the order": "Ouvrir la commande",
  "Open the order in the shop": "Ouvrir la commande dans la boutique",
  "Opening…": "Ouverture…",
  "Opens in a new tab": "S'ouvre dans un nouvel onglet",
  "Order": "Commande",
  "Order {id}": "Commande {id}",
  "Orders": "Commandes",
  "Other merchants": "Autres marchands",
  "Other merchants find {shop}": "Les autres marchands trouvent {shop}",
  "Other orders": "Autres commandes",
  "Paid": "Payé",
  "Partly working": "Fonctionne en partie",
  "Pictures, PDF, text, Word and Excel files only": "Uniquement des images et des fichiers PDF, texte, Word et Excel",
  "PIN code": "Code PIN",
  "PIN codes": "Codes PIN",
  "Private message": "Message privé",
  "Read and reply: {url}": "Lire et répondre : {url}",
  "Read and search your conversations": "Lire et rechercher dans vos conversations",
  "Recent": "Récents",
  "Recipient": "Destinataire",
  "Refunded": "Remboursé",
  "Reload": "Actualiser",
  "Remove": "Retirer",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Répondez dans l'app Johku ou sur {url}, connecté avec cette adresse e-mail.",
  "Resolved": "Résolu",
  "Resolved: {title}": "Résolu : {title}",
  "Row {row}, seat {seat}": "Rang {row}, place {seat}",
  "Sales channel offer": "Offre de canal de vente",
  "Save": "Enregistrer",
  "Saved in Downloads": "Enregistré dans Téléchargements",
  "Saving files needs Android 10 or newer": "L'enregistrement de fichiers nécessite Android 10 ou plus récent",
  "Search": "Recherche",
  "Search by name": "Rechercher par nom",
  "Search conversations": "Rechercher dans les conversations",
  "Seat {seat}": "Place {seat}",
  "See all": "Tout voir",
  "Sell, check tickets and answer customers in Johku App.": "Vendez, contrôlez les billets et répondez aux clients dans Johku App.",
  "Send": "Envoyer",
  "Send as": "Envoyer en tant que",
  "Send code": "Envoyer le code",
  "Send messages and start conversations as you": "Envoyer des messages et lancer des conversations en votre nom",
  "Send now": "Envoyer maintenant",
  "Send the offer": "Envoyer l'offre",
  "Send to members": "Envoyer aux membres",
  "Send to shops": "Envoyer aux boutiques",
  "Send update": "Envoyer la mise à jour",
  "Sending…": "Envoi…",
  "Sent to {done} of {n} people": "Envoyé à {done} sur {n} personnes",
  "Sent to {done} of {n} person": "Envoyé à {done} sur {n} personne",
  "Severity": "Gravité",
  "Shop": "Boutique",
  "Show booking": "Voir la réservation",
  "Show conversations of": "Afficher les conversations de",
  "Show more": "Afficher plus",
  "Show orders of": "Afficher les commandes de",
  "Show the code at the door.": "Présentez le code à l'entrée.",
  "Show the code at the till, or type it in the shop's online store.": "Présentez le code en caisse ou saisissez-le dans la boutique en ligne.",
  "Show tickets": "Voir les billets",
  "Show used and expired codes": "Afficher les codes utilisés et expirés",
  "Sign in": "Se connecter",
  "Sign in again": "Se reconnecter",
  "Sign in to Johku Hub": "Se connecter à Johku Hub",
  "Sign in with an email code": "Se connecter avec un code par e-mail",
  "Sign in with Johku": "Se connecter avec Johku",
  "Sign out": "Se déconnecter",
  "Sign out of {email}? Its messages are removed from this device.": "Se déconnecter de {email} ? Ses messages seront supprimés de cet appareil.",
  "Sign out of this account": "Se déconnecter de ce compte",
  "Sign out?": "Se déconnecter ?",
  "Signing in with Johku didn't finish. Please try again.": "La connexion avec Johku n'a pas abouti. Veuillez réessayer.",
  "Signing in with Johku didn't work ({error}).": "La connexion avec Johku n'a pas fonctionné ({error}).",
  "Signing in…": "Connexion…",
  "So you see customers' questions right away": "Pour voir tout de suite les questions des clients",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Certaines boutiques n'ont pas répondu, leurs codes peuvent donc manquer : {shops}",
  "Someone": "Quelqu'un",
  "Something went wrong.": "Une erreur s'est produite.",
  "Something went wrong. Please try again.": "Une erreur s'est produite. Veuillez réessayer.",
  "Start the conversation": "Commencer la conversation",
  "Status": "Statut",
  "Subject (optional)": "Objet (facultatif)",
  "Swipe for the next one": "Balayez pour le suivant",
  "Switch shop": "Changer de boutique",
  "That code has expired. Ask for a new one.": "Ce code a expiré. Demandez-en un nouveau.",
  "That code isn't right. Check it and try again.": "Ce code n'est pas correct. Vérifiez-le et réessayez.",
  "The code is on its way. Check again in a moment.": "Le code arrive. Revenez voir dans un instant.",
  "The conversation was declined.": "La conversation a été refusée.",
  "The download failed": "Le téléchargement a échoué",
  "The file is larger than 20 MB": "Le fichier dépasse 20 Mo",
  "The Johku team": "L'équipe Johku",
  "The Johku team keeps you posted here until it's resolved.": "L'équipe Johku vous tient informé ici jusqu'à la résolution.",
  "The order page can't be opened right now. Try again in a moment.": "La page de la commande ne peut pas être ouverte pour le moment. Réessayez dans un instant.",
  "The phone's language": "Langue du téléphone",
  "The PIN code and instructions show from {time}.": "Le code PIN et les instructions s'affichent à partir du {time}.",
  "The tickets can't be opened right now. Try again in a moment.": "Les billets ne peuvent pas être ouverts pour le moment. Réessayez dans un instant.",
  "There's no one {name} can write to yet.": "Il n'y a encore personne à qui {name} puisse écrire.",
  "These tickets aren't available any more.": "Ces billets ne sont plus disponibles.",
  "this account": "ce compte",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Ce message part maintenant vers le personnel de {n} boutique, par notification et e-mail. L'envoyer ?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Ce message part maintenant vers le personnel de {n} boutiques, par notification et e-mail. L'envoyer ?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Ce message part maintenant vers le personnel de toutes les boutiques, par notification et e-mail. L'envoyer ?",
  "This incident isn't shown any more.": "Cet incident n'est plus affiché.",
  "This order has been cancelled. Its tickets aren't valid.": "Cette commande a été annulée. Ses billets ne sont pas valables.",
  "This order has been refunded. Its tickets aren't valid.": "Cette commande a été remboursée. Ses billets ne sont pas valables.",
  "Ticket": "Billet",
  "Ticket {n} of {total}": "Billet {n} sur {total}",
  "Tickets": "Billets",
  "Tickets at hand": "Vos billets toujours à portée de main",
  "To (email)": "À (e-mail)",
  "To members": "Aux membres",
  "To the members of {collection}: {n} member": "Aux membres de {collection} : {n} membre",
  "To the members of {collection}: {n} members": "Aux membres de {collection} : {n} membres",
  "To the members of {collection}: sending, {sent}/{n}": "Aux membres de {collection} : envoi en cours, {sent}/{n}",
  "Today": "Aujourd'hui",
  "Total": "Total",
  "Turn on notifications": "Activer les notifications",
  "Unpaid": "Non payé",
  "Upcoming": "À venir",
  "Update to the shops": "Mise à jour pour les boutiques",
  "Use another address": "Utiliser une autre adresse",
  "Used": "Utilisé",
  "Uses": "Utilisations",
  "Valid from {date}": "Valable à partir du {date}",
  "Valid until {date}": "Valable jusqu'au {date}",
  "Validity": "Validité",
  "Value left": "Valeur restante",
  "Venue": "Lieu",
  "Waiting for {shop} to accept the conversation.": "En attente que {shop} accepte la conversation.",
  "Waiting for an answer": "En attente de réponse",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Nous vous enverrons un code de connexion par e-mail. Utilisez l'adresse que vous utilisez avec Johku.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Ce qui ne fonctionne pas, qui est concerné et que faire en attendant.",
  "What you offer, and what kind of partners you look for": "Ce que vous proposez et quels partenaires vous cherchez",
  "What's wrong": "Ce qui ne va pas",
  "When": "Quand",
  "When something in Johku doesn't work, and when it's fixed": "Quand quelque chose ne fonctionne pas sur Johku, et quand c'est réparé",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Quand vous achetez dans une boutique Johku avec {email}, la commande apparaît ici automatiquement.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Quand vous achetez dans une boutique Johku avec votre adresse e-mail, la commande apparaît ici automatiquement.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Si les autres marchands Johku trouvent votre boutique et peuvent l'inviter à une conversation",
  "With the customer": "Avec le client",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Avec votre e-mail, Google ou Microsoft, comme dans les boutiques en ligne Johku.",
  "Withdraw the offer": "Retirer l'offre",
  "Withdrawn": "Retirée",
  "Withdrew the offer.": "A retiré l'offre.",
  "Write to the customer": "Écrire au client",
  "Write to the shop": "Écrire à la boutique",
  "Yesterday": "Hier",
  "You": "Vous",
  "You can close this page.": "Vous pouvez fermer cette page.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Vous recevez ce message car vous travaillez dans une boutique qui utilise Johku. Suivez la situation dans l'application Johku ou sur {url}.",
  "You: ": "Vous : ",
  "You'll see replies without opening the app.": "Vous verrez les réponses sans ouvrir l'application.",
  "You're offline. A new conversation needs a connection.": "Vous êtes hors ligne. Une nouvelle conversation nécessite une connexion.",
  "You're offline. The first message needs a connection.": "Vous êtes hors ligne. Le premier message nécessite une connexion.",
  "You're offline. Try again when the connection returns.": "Hors ligne. Réessayez lorsque la connexion sera rétablie.",
  "You're staff at {shop}": "Vous faites partie de l'équipe de {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Vos codes ne peuvent pas être chargés pour le moment. Réessayez dans un instant.",
  "Your conversations with shops about your orders show up here.": "Vos conversations avec les boutiques au sujet de vos commandes s'affichent ici.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Votre compte Johku n'a pas encore accès à Johku Hub.",
  "Your Johku Hub sign-in code is {code}.": "Votre code de connexion Johku Hub est {code}.",
  "Your orders": "Vos commandes",
  "Your orders can't be loaded right now. Try again in a moment.": "Vos commandes ne peuvent pas être chargées pour le moment. Réessayez dans un instant.",
  "Your other accounts stay signed in.": "Vos autres comptes restent connectés.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Vos autres comptes restent connectés. Passez de l'un à l'autre depuis votre photo sur l'Accueil.",
  "Your session for {account} has ended. Please sign in again.": "Votre session pour {account} a expiré. Veuillez vous reconnecter.",
  "Your shop": "Votre boutique",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Votre boutique n'a pas de canal de vente dans Johku. Créez-en un d'abord dans les réglages de l'app Johku.",
  "Your shops": "Vos boutiques",
  "Your tickets will show up here": "Vos billets s'afficheront ici",
  "Your tickets, orders and messages with shops": "Vos billets, commandes et messages avec les boutiques"
}
